var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148617",
    "data-name": "Rectangle 148617",
    width: 24,
    height: 24,
    transform: "translate(0.189 0.089)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google",
    transform: "translate(-0.189 -0.089)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(0.732 0.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8915",
    "data-name": "Path 8915",
    d: "M5.054,145.891l-.794,2.964-2.9.061a11.423,11.423,0,0,1-.084-10.648h0l2.583.474,1.132,2.568a6.805,6.805,0,0,0,.064,4.582Z",
    transform: "translate(0 -132.109)",
    fill: "#fbbb00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8916",
    "data-name": "Path 8916",
    d: "M272.581,208.176a11.4,11.4,0,0,1-4.065,11.023h0l-3.254-.166-.46-2.875a6.8,6.8,0,0,0,2.924-3.47h-6.1v-4.511h10.953Z",
    transform: "translate(-249.974 -198.903)",
    fill: "#518ef8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8917",
    "data-name": "Path 8917",
    d: "M47.691,315.922h0a11.407,11.407,0,0,1-17.183-3.489l3.7-3.025a6.782,6.782,0,0,0,9.773,3.472Z",
    transform: "translate(-29.15 -295.627)",
    fill: "#28b446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8918",
    "data-name": "Path 8918",
    d: "M46.031,2.625,42.336,5.649a6.781,6.781,0,0,0-10,3.551L28.625,6.159h0A11.405,11.405,0,0,1,46.031,2.625Z",
    transform: "translate(-27.349)",
    fill: "#f14336"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f2f1e6bc.svg";
export { ForwardRef as ReactComponent };